"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClaimTokenHelperV3Factory = void 0;
const ethers_1 = require("ethers");
const _abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "holder",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "totalTonicAmount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "tonicAmountToStake",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "xTonicAmount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "vaultPoolId",
                type: "uint256",
            },
        ],
        name: "ClaimTonicAndDelayedEmissions",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint8",
                name: "version",
                type: "uint8",
            },
        ],
        name: "Initialized",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "tectonicSocketAddress",
                type: "address",
            },
        ],
        name: "addTectonicSocketAddress",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "partnerToken",
                type: "address",
            },
            {
                internalType: "address",
                name: "holder",
                type: "address",
            },
            {
                internalType: "address[]",
                name: "tokenRewarders",
                type: "address[]",
            },
        ],
        name: "claimNonTonicToken",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address[]",
                name: "partnerTokens",
                type: "address[]",
            },
            {
                internalType: "address",
                name: "holder",
                type: "address",
            },
            {
                internalType: "address[]",
                name: "tokenRewarders",
                type: "address[]",
            },
        ],
        name: "claimNonTonicTokens",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "claimTokenHelperVersion",
        outputs: [
            {
                internalType: "uint8",
                name: "",
                type: "uint8",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "holder",
                type: "address",
            },
            {
                internalType: "address[]",
                name: "tectonicCores",
                type: "address[]",
            },
            {
                internalType: "uint256",
                name: "depositPercentage",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "vaultPoolId",
                type: "uint256",
            },
        ],
        name: "claimTonic",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "holder",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "depositPercentage",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "vaultPoolId",
                type: "uint256",
            },
        ],
        name: "claimTonic",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "defaultDepositPercentage",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "defaultVaultPoolId",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getTectonicSocketAddressSet",
        outputs: [
            {
                internalType: "address[]",
                name: "",
                type: "address[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "holder",
                type: "address",
            },
            {
                internalType: "address[]",
                name: "partnerTokens",
                type: "address[]",
            },
            {
                internalType: "address[]",
                name: "tokenRewarders",
                type: "address[]",
            },
        ],
        name: "getUnclaimedPartnerTokensForUser",
        outputs: [
            {
                internalType: "uint256[]",
                name: "unclaimedAmounts",
                type: "uint256[]",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract IERC20Upgradeable",
                name: "_tonic",
                type: "address",
            },
            {
                internalType: "contract IERC20Upgradeable",
                name: "_xTonic",
                type: "address",
            },
            {
                internalType: "address",
                name: "_stakingPoolAddress",
                type: "address",
            },
            {
                internalType: "address",
                name: "_vaultAddress",
                type: "address",
            },
            {
                internalType: "address",
                name: "_tectonicSocketAddress",
                type: "address",
            },
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "tectonicSocketAddress",
                type: "address",
            },
        ],
        name: "removeTectonicSocketAddress",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_defaultDepositPercentage",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_defaultVaultPoolId",
                type: "uint256",
            },
        ],
        name: "setDelayedEmissionsParameter",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "stakingPoolAddress",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "tectonicSocketAddress",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "tonic",
        outputs: [
            {
                internalType: "contract IERC20Upgradeable",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "holder",
                type: "address",
            },
        ],
        name: "tonicDelayedEmissions",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "vaultAddress",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "xTonic",
        outputs: [
            {
                internalType: "contract IERC20Upgradeable",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
const _bytecode = "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";
class ClaimTokenHelperV3Factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (args.length === 1) {
            super(_abi, _bytecode, args[0]);
        }
        else {
            super(...args);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.ClaimTokenHelperV3Factory = ClaimTokenHelperV3Factory;
ClaimTokenHelperV3Factory.bytecode = _bytecode;
ClaimTokenHelperV3Factory.abi = _abi;
//# sourceMappingURL=ClaimTokenHelperV3Factory.js.map